import { render, staticRenderFns } from "./OlderConversationsIcon.vue?vue&type=template&id=0127c668&"
import script from "./OlderConversationsIcon.vue?vue&type=script&lang=js&"
export * from "./OlderConversationsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports